<template>
	<div v-if="renderBlank == false">
		<v-toolbar class="navbar" style="flex: none !important">
			<LogosColumn />
			<v-spacer></v-spacer>
			<!-- Login and Register page -->
			<template
				v-if="currentRoute.name === 'Login' || currentRoute.name == 'Register' || currentRoute.name === 'SelfSignup'"
			>
				<div>
					<div v-if="currentRoute.name === 'Login'">
						<!-- <router-link :to="{ name: 'Register' }" id="register" class="navBarLink">Inscription</router-link> -->
						<a href="https://www.orthographiq.com/offres/formation-orthographe" target="_blank" class="navBarLink">
							Inscription
						</a>
					</div>
					<div v-else-if="currentRoute.name === 'Register' || currentRoute.name === 'SelfSignup'">
						<router-link to="/login" id="login" class="navBarLink">Connexion</router-link>
					</div>
				</div>
			</template>
			<!-- End Login and Register page -->

			<template v-else-if="userHaveFormations === true">
				<div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex align-center">
					<TopicDropdownDesktop v-if="showTopicDropdown()" />
					<SessionParcoursNavItemsDesktop
						v-if="showRedactionNav"
						:currentRoute="currentRoute"
						:parcoursId="formationInfos.parcours_id"
					/>
					<template v-else>
						<OrthographNavItemsDesktop
							v-if="orthographiqFormation"
							:currentRoute="currentRoute"
							:formationId="orthographiqFormation._id"
						/>
					</template>
				</div>
				<div v-if="$vuetify.breakpoint.smAndDown">
					<SessionParcoursNavItemsMobile
						v-if="showRedactionNav"
						:currentRoute="currentRoute"
						:formationId="formationInfos._id"
					/>
					<template v-else>
						<OrthographNavItemsMobile
							v-if="orthographiqFormation"
							:currentRoute="currentRoute"
							:formationId="orthographiqFormation._id"
						/>
					</template>
				</div>
			</template>
			<template v-else-if="userHaveFormations === false">
				<OnlyHaveTestNav :currentRoute="currentRoute" />
			</template>
		</v-toolbar>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import LogosColumn from './LogosColumn';
import OrthographNavItemsDesktop from './OrthographNavItemsDesktop.vue';
import OrthographNavItemsMobile from './OrthographNavItemsMobile.vue';
import SessionParcoursNavItemsDesktop from './SessionParcoursNavItemsDesktop.vue';
import SessionParcoursNavItemsMobile from './SessionParcoursNavItemsMobile.vue';
import TopicDropdownDesktop from './TopicDropdownDesktop.vue';
import OnlyHaveTestNav from './OnlyHaveTestNav.vue';
import { showRedactionNavItems } from '@/utils/navbar.js';

export default {
	name: 'NavBar',
	components: {
		LogosColumn,
		OrthographNavItemsDesktop,
		OrthographNavItemsMobile,
		SessionParcoursNavItemsDesktop,
		SessionParcoursNavItemsMobile,
		TopicDropdownDesktop,
		OnlyHaveTestNav,
	},
	props: {
		formationInfos: Object,
		categoriesDone: Array,
		currentRoute: Object,
	},
	data() {
		return {
			userHaveFormations: null,
		};
	},
	computed: {
		...mapGetters('profile', {
			formationProgress: 'formationProgress',
			orthographiqFormation: 'orthographiqFormation',
			allFormationsAndConfigs: 'allFormationsAndConfigs',
		}),
		...mapGetters('tests', { testBank: 'testBank' }),
		renderBlank() {
			const PagesDontNeedNavBar = [
				'LoginSSO',
				'MicrosoftCallback',
				'PrintTrackExpressionAnswerPage',
				'PublicViewCertificatePage',
				'PublicCertificateRedirectLinkedinPage',
			];
			return PagesDontNeedNavBar.includes(this.currentRoute.name);
		},
		showRedactionNav() {
			if (this.currentRoute.name === 'TestHomePage' && this.currentRoute.query.topicSlug !== 'orthographe') return true;
			if (
				this.currentRoute.name === 'TestResultPage' &&
				this.currentRoute.query.testHomePageTopicSlugQuery !== 'orthographe'
			)
				return true;
			if (
				this.currentRoute.name === 'DoTestPage' &&
				localStorage.getItem('token') != null &&
				this.allFormationsAndConfigs != null &&
				this.allFormationsAndConfigs.length > 0 &&
				this.testBank != null
			) {
				const topicId = this.testBank.topic_id;
				const formation = this.allFormationsAndConfigs.find((f) => f.config.topic_id._id === topicId);
				if (formation != null) {
					this.$store.dispatch('profile/formationProgress', { idFormation: formation._id });
					this.$store.dispatch('appState/selectFormationId', { formationId: formation._id });
					return formation.for_session === true;
				}
			}

			const formation = this.formationProgress ? this.formationProgress.formation : this.formationInfos;
			return showRedactionNavItems(this.currentRoute.name) || formation.for_session;
		},
	},
	async created() {
		this.userHaveFormations = await this.checkUserHaveFormation();
	},
	methods: {
		showTopicDropdown() {
			const routeNames = [
				'Topic Dashboard',
				'Topic Dashboard Index',
				'Topic Dashboard Parcours Detail',
				'Topic Dashboard Chapter Detail',
				'Dashboard',
				'Profile',
				'Profile Index',
				'Parcours Detail',
				'Category Detail',
				'Orthographiq Leaderboard Weekly',
				'Topic Leaderboard Weekly',
			];
			return routeNames.includes(this.currentRoute.name);
		},
		async checkUserHaveFormation() {
			if (localStorage.getItem('token') == null) return null;

			axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
			const formationRes = await axios.get('/api/formation');
			return formationRes.data.formations.length > 0;
		},
	},
	watch: {
		async '$route.name'() {
			if (this.allFormationsAndConfigs == null && localStorage.getItem('token') != null) {
				await this.$store.dispatch('profile/fetchAllFormationsAndTopic');
			}
			if (this.userHaveFormations == null) this.userHaveFormations = await this.checkUserHaveFormation();
		},
	},
};
</script>

<style lang="scss" scoped>
.v-list-item {
	min-height: auto !important;
}
.navBarLink {
	font-weight: 500;
	letter-spacing: 0.0892857143em;
	text-transform: uppercase;
	font-size: 12px;
	color: #989fa9;
}

::v-deep {
	.navbar {
		height: fit-content !important;
		.v-toolbar__content {
			height: fit-content !important;
		}
		h2 {
			border-left: 1px solid #989fa9;
		}
	}
}

@media screen and (max-width: 600px) {
	.navbar {
		position: relative;
		z-index: 10;
	}
	a {
		&:first-child:not(#login) {
			border-right: none;
		}
	}
	.v-list {
		padding: 0px;
	}
	.v-list-item {
		position: absolute;
		background: white;
		right: 0px;
		padding: 10px;
		margin-right: 10px;
		border: 1px solid #989fa9;
	}
}
</style>
